/**
 * This is a variant of the redux combineReducers function, where the reducers
 * are called in a specified sequence, and each reducer also has access to the
 * new state generated by preceding reducers.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one.
 *
 * @param {Array} sequence An array of strings indicating the sequence in
 * which the reducers should be invoked.
 *
 * @returns {Function} A reducer function that invokes reducers in the
 * specified sequence, and builds the new combined state object.
 */
export default function sequenceReducers(reducers, sequence) {
  return function combination(state = {}, action) {
    let hasChanged = false
    let nextState = {}
    sequence.forEach((key) => {
      const reducer = reducers[key]
      const previousStateForKey = state[key]
      const nextStateForKey = reducer(previousStateForKey, action, nextState)
      nextState[key] = nextStateForKey
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey
    })
    return hasChanged ? nextState : state
  }
}
